var _a;
import { __assign } from "tslib";
import { SocialNetwork } from '../../SocialIcon';
import { useReducer, useEffect } from 'react';
export var ActionType;
(function (ActionType) {
    ActionType[ActionType["TITLE_CHANGE"] = 0] = "TITLE_CHANGE";
    ActionType[ActionType["DESCRIPTION_CHANGE"] = 1] = "DESCRIPTION_CHANGE";
    ActionType[ActionType["BIOGRAPHY_CHANGE"] = 2] = "BIOGRAPHY_CHANGE";
    ActionType[ActionType["GALLERYID_CHANGE"] = 3] = "GALLERYID_CHANGE";
    ActionType[ActionType["SET_GALLERY_DEVIATIONS"] = 4] = "SET_GALLERY_DEVIATIONS";
    ActionType[ActionType["THEMEID_CHANGE"] = 5] = "THEMEID_CHANGE";
    ActionType[ActionType["SOCIAL_NETWORK_CHANGE"] = 6] = "SOCIAL_NETWORK_CHANGE";
    ActionType[ActionType["TERMS_CHANGE"] = 7] = "TERMS_CHANGE";
    ActionType[ActionType["INITIALIZE"] = 8] = "INITIALIZE";
})(ActionType || (ActionType = {}));
export var initialSocialNetworksLinksValue = (_a = {},
    _a[SocialNetwork.BEHANCE] = '',
    _a[SocialNetwork.DRIBBLE] = '',
    _a[SocialNetwork.ETSY] = '',
    _a[SocialNetwork.FACEBOOK] = '',
    _a[SocialNetwork.FLICKR] = '',
    _a[SocialNetwork.INSTAGRAM] = '',
    _a[SocialNetwork.LINKEDIN] = '',
    _a[SocialNetwork.PATREON] = '',
    _a[SocialNetwork.PINTEREST] = '',
    _a[SocialNetwork.TUMBLR] = '',
    _a[SocialNetwork.TWITCH] = '',
    _a[SocialNetwork.TWITTER] = '',
    _a[SocialNetwork.VIMEO] = '',
    _a[SocialNetwork.YOUTUBE] = '',
    _a);
// It's possible for this to be overridden inside the hook that uses it via PreloadedFormState
var initialState = {
    title: '',
    description: '',
    biography: '',
    themeId: '',
    socialNetworkLinks: initialSocialNetworksLinksValue,
};
function formReducer(state, _a) {
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case ActionType.TITLE_CHANGE:
            return __assign(__assign({}, state), { title: payload.value });
        case ActionType.BIOGRAPHY_CHANGE:
            return __assign(__assign({}, state), { biography: payload.value });
        case ActionType.DESCRIPTION_CHANGE:
            return __assign(__assign({}, state), { description: payload.value });
        case ActionType.GALLERYID_CHANGE:
            return __assign(__assign({}, state), { galleryId: payload.value });
        case ActionType.SOCIAL_NETWORK_CHANGE:
            var updatedState = __assign(__assign({}, state), { socialNetworkLinks: __assign({}, state.socialNetworkLinks) });
            updatedState.socialNetworkLinks[payload.network] = payload.value;
            return updatedState;
        case ActionType.THEMEID_CHANGE:
            return __assign(__assign({}, state), { themeId: payload.value });
        case ActionType.TERMS_CHANGE:
            return __assign(__assign({}, state), { hasAcceptedTerms: payload.value });
        case ActionType.SET_GALLERY_DEVIATIONS:
            return __assign(__assign({}, state), { galleryDeviations: payload.deviations });
        case ActionType.INITIALIZE:
            return __assign(__assign({}, state), payload);
        default:
            return state;
    }
}
export function useWixPortfolioFormState(preloadedState) {
    var initialFormState = __assign(__assign({}, initialState), preloadedState);
    var _a = useReducer(formReducer, initialFormState), formState = _a[0], dispatch = _a[1];
    // in case preloaded state gets lazy loaded
    useEffect(function () {
        dispatch({ type: ActionType.INITIALIZE, payload: preloadedState });
    }, [preloadedState]);
    return {
        initialFormState: initialFormState,
        formState: formState,
        dispatch: dispatch,
    };
}
// These are preemptive functions since we're going to be prepopulating some of these values
// Seems like it'd be easier to update them with the incoming changes if they were centralized.
export function wasSocialNetworksChanged(initialFormState, formState) {
    return formState.socialNetworkLinks !== initialFormState.socialNetworkLinks;
}
export function wasBiographyChanged(initialFormState, formState) {
    return formState.biography !== initialFormState.biography;
}
export function wasTitleChanged(initialFormState, formState) {
    return formState.title !== initialFormState.title;
}
export function wasDescriptionChanged(formState) {
    return formState.description !== initialState.description;
}
export function wasThemeChanged(initialFormState, formState) {
    return formState.themeId !== initialFormState.themeId;
}
//# sourceMappingURL=state.js.map